// Estilos base del rediseño (Claude Design · "Rediseño panel CHARGOY").
// Botones grandes (48–56 px) y letra de 16–18 px: el panel se usa de pie,
// con prisa y a veces por gente mayor.
import type { CSSProperties } from 'react';

export const btnPrimario: CSSProperties = {
  height: 56, padding: '0 20px', borderRadius: 12, border: 'none',
  background: 'var(--brand)', color: 'var(--on-brand)', fontSize: 18, fontWeight: 700, cursor: 'pointer',
};

export const btnSecundario: CSSProperties = {
  height: 48, padding: '0 16px', borderRadius: 10, border: '1px solid var(--line-strong)',
  background: 'var(--surface)', color: 'var(--ink)', fontSize: 16, fontWeight: 700, cursor: 'pointer',
};

export const tarjeta: CSSProperties = {
  background: 'var(--surface)', border: '1px solid var(--line)', borderRadius: 16,
};

// Control segmentado (zonas, vistas, periodos): riel `well` con la opción activa en `surface`.
export const segmentos: CSSProperties = {
  display: 'flex', gap: 4, padding: 4, background: 'var(--well)', borderRadius: 12,
};

export const segmento = (activo: boolean): CSSProperties => ({
  height: 48, padding: '0 16px', border: 'none', borderRadius: 9, fontSize: 16, fontWeight: 700,
  cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8, color: 'var(--ink)',
  background: activo ? 'var(--surface)' : 'transparent',
  boxShadow: activo ? '0 1px 3px rgba(40,30,20,.15)' : 'none',
});

export const chip = (bg: string, fg: string): CSSProperties => ({
  padding: '4px 10px', borderRadius: 999, fontSize: 14, fontWeight: 700,
  background: bg, color: fg, whiteSpace: 'nowrap',
});

export const campo: CSSProperties = {
  height: 52, padding: '0 16px', borderRadius: 12, border: '1px solid var(--line-strong)',
  fontSize: 16, background: 'var(--surface)', color: 'var(--ink)', width: '100%',
};

export const money = (n: number) => '$' + Math.round(n || 0).toLocaleString('es-MX');
// Con centavos: donde se cobra y se da cambio, $40.50 no es $41.
export const pesos = (n: number) => '$' + (n || 0).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
